export default class Utils {

  public static getDateFormated(date: Date | undefined) {
    if(date === undefined) return undefined
    return new Date(date).toLocaleDateString('de-de', {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }

  public static getDateFormatedEN(date: Date | undefined) {
    if(date === undefined) return undefined
    return new Date(date).toLocaleDateString('en-en', {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }

  public static getJobType(type: number | undefined) {
    if(type === undefined) return undefined
    if (type === 1) {
      return "Arbeitnehmerüberlassung"
    } else if (type === 2) {
      return "Personalvermittlung"
    } else {
      return "?"
    }
  }
}
